import Wrapper from "../wrappers/horizontalDelimiter";

const HorizontalDelimiter = () => {
  return <Wrapper className="horizontal-delimiter">Or</Wrapper>;
};

export default HorizontalDelimiter;
